export { camelize, capitalize, hyphenate, hyphenate as kebabCase } from '@vue/shared';

const escapeRegexpString = (value = "") => String(value).replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");

export { escapeRegexpString };
//# sourceMappingURL=strings.mjs.map
